export const areItemIdsEqual = (first: string[], second: string[]): boolean => {
  return first.length === second.length && first.every((id, index) => id === second[index]);
};

export const getOrderedVisibleItemIds = (itemIds: string[], visibleItemIds: Set<string>): string[] => {
  return itemIds.filter((id) => visibleItemIds.has(id));
};
